var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.message
    ? _c("div", { class: _vm.getAlertClass() }, [
        _c("button", {
          staticClass: "close",
          attrs: { type: "button" },
          on: { click: _vm.close },
        }),
        _vm._v(" "),
        _c("strong", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" " + _vm._s(_vm.getMessage()) + "\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }